import { render, staticRenderFns } from "./ztxcTs.vue?vue&type=template&id=b689b318"
import script from "./ztxcTs.vue?vue&type=script&lang=js"
export * from "./ztxcTs.vue?vue&type=script&lang=js"
import style0 from "./ztxcTs.vue?vue&type=style&index=0&id=b689b318&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports